import { render, staticRenderFns } from "./OrgTable.vue?vue&type=template&id=2d168d0f"
import script from "./OrgTable.vue?vue&type=script&lang=js"
export * from "./OrgTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports